<template>
  <div
    ref="formContainer"
    :class="[
      'tw-w-full tw-flex tw-flex-col tw-relative tw-h-full',
      'tw-overflow-auto scrollbar-hide',
    ]"
  >
    <div
      :class="[
        'tw-text-h3-bold-mobile apTablet2:tw-text-h3-bold-desktop',
        'tw-mt-8 tw-mb-[64px]',
      // 'dark:tw-text-white'
      ]"
    >Tell us about yourself</div>
    <div class="tw-grid tw-grid-cols-1 apDesktop:tw-grid-cols-2 tw-gap-x-4 tw-gap-y-[32px] apDesktop:tw-gap-y-[64px] tw-pb-[72px]">
      <TextForm v-model:data="contactUs.name" :title="'Your name'" :placeholder="'Enter your name'" />
      <TextForm v-model:data="contactUs.email" :title="'Email'" :placeholder="'mail@example.com'" :error-msg="emailErrorMessage" />
      <TextForm v-model:data="contactUs.organization" :title="'Your organisation'" :placeholder="'Acme Corp.'" />
      <TextForm v-model:data="contactUs.role" :title="'Your role'" :placeholder="'Marketing Manager'" />
      <DropDownForm v-model:data="contactUs.organization_type" :title="'How would you describe your organisation?'" placeholder="Please select" :options="organisationType" :form-container="formContainer" />
      <PhoneForm v-model:country-code="contactUs.country_code" v-model:phone-number="contactUs.contact_number" :title="'Contact number'" :is-optional="true" :form-container="formContainer" />
    </div>
    <div class="apDesktop:tw-mb-[64px] tw-mb-[78px]">
      <NextButton label="Next" :enable="allowNextButton" @click="emit('clickNext')" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { ContactUs } from '../../model/interfaces/ContactUs';
import DropDownForm from '../shared/DropDownForm.vue';
import PhoneForm from '../shared/PhoneForm.vue';
import TextForm from '../shared/TextForm.vue';
import NextButton from './NextButton.vue';

const props = defineProps < {
  contactUs: ContactUs
} > ();

const emit = defineEmits(['clickNext']);

const formContainer = ref();
const emailErrorMessage = ref('');
const allowNextButton = computed(() => {
  return props.contactUs.isValidEmail() &&
    props.contactUs.isValidName() &&
    props.contactUs.isValidOrganization() &&
    props.contactUs.isValidRole() &&
    props.contactUs.isValidOrganizationType()
});

const organisationType = ref(
  [
    'Startup',
    'Small/Medium Business',
    'Large Corporation',
    'Non-profit',
    'Other'
  ]
);

watch(props.contactUs, () => {
  if (props.contactUs.isValidEmail() || props.contactUs.email.trim().length === 0) {
    emailErrorMessage.value = '';
  }else{
    emailErrorMessage.value = 'Please enter a valid email address';
  }
}, { deep: true });

</script>

<style scoped>
.scrollbar-hide::-webkit-scrollbar {
    display: none;
}

/* For IE, Edge and Firefox */
.scrollbar-hide {
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
</style>